import { jsx as l } from "react/jsx-runtime";
import { RadioGroup as G, Radio as y } from "@blueprintjs/core";
import { FormFieldWrapper as M } from "@strata/react-form-field-wrapper";
import "./main.scss";
import { getValidationMessage as N } from "@strata/helper-functions";
import { Field as V } from "formik";
const h = ({
  name: n,
  options: d,
  selectedValue: r = "",
  onChange: a = void 0,
  label: m = "",
  helperText: p,
  disabled: i = !1,
  inline: u = !1,
  inlineItems: c = void 0,
  fill: v,
  required: b = !1,
  requiredValidationMessage: F,
  verticalSpacingSmall: f = !0,
  onBlur: O,
  autoFocus: R = !1,
  tabIndex: g,
  inputRef: x
}) => /* @__PURE__ */ l(
  M,
  {
    label: m,
    labelFor: n,
    disabled: i,
    helperText: p,
    inline: u,
    fill: v,
    required: b,
    requiredValidationMessage: F,
    verticalSpacingSmall: f,
    inputContent: /* @__PURE__ */ l(
      G,
      {
        className: "sds_radio-button-group",
        name: n,
        disabled: i,
        inline: u || c,
        onChange: (t) => a == null ? void 0 : a(t.currentTarget.value),
        selectedValue: r,
        children: d.map((t, o) => {
          const e = typeof t == "object", s = e ? t.value : t, _ = e ? t.component ?? t.text : t, j = i || (e ? t.disabled : void 0), B = !r && o === 0 || r === s;
          return /* @__PURE__ */ l(
            y,
            {
              className: "sds_radio-button-group__button-text",
              labelElement: _,
              value: s,
              disabled: j,
              tabIndex: g,
              onBlur: O,
              autoFocus: (
                // autoFocus is either the first option, or the currently selected option
                B ? R : void 0
              ),
              inputRef: (
                // inputRef is either the first option, or the currently selected option
                B ? x : void 0
              )
            },
            s
          );
        })
      }
    )
  }
), T = ({
  name: n,
  options: d,
  selectedValue: r,
  onChange: a,
  label: m,
  helperText: p,
  disabled: i,
  inline: u,
  inlineItems: c,
  fill: v,
  required: b,
  requiredValidationMessage: F,
  verticalSpacingSmall: f,
  onBlur: O,
  autoFocus: R,
  tabIndex: g,
  inputRef: x,
  validate: t = void 0
}) => /* @__PURE__ */ l(V, { name: n, validate: t, children: ({ field: o, form: e }) => /* @__PURE__ */ l(
  h,
  {
    options: d,
    selectedValue: r ?? o.value,
    onChange: a ?? ((s) => e.setFieldValue(o.name, s)),
    onBlur: O ?? e.handleBlur,
    name: o.name,
    label: m,
    helperText: p,
    disabled: i,
    required: b,
    requiredValidationMessage: F ?? N(o.name, e),
    verticalSpacingSmall: f,
    inline: u,
    inlineItems: c,
    fill: v,
    autoFocus: R,
    tabIndex: g,
    inputRef: x
  }
) });
export {
  h as RadioButtonGroup,
  T as RadioButtonGroupFormik
};
//# sourceMappingURL=index.js.map
